// @generated by protoc-gen-es v1.8.0 with parameter "target=ts"
// @generated from file gitpod/v1/gateway.proto (package gitpod.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";
import { PaginationRequest, PaginationResponse } from "./pagination_pb.js";

/**
 * @generated from message gitpod.v1.ListGatewaysRequest
 */
export class ListGatewaysRequest extends Message<ListGatewaysRequest> {
  /**
   * pagination contains the pagination options for listing gateways
   *
   * @generated from field: gitpod.v1.PaginationRequest pagination = 1;
   */
  pagination?: PaginationRequest;

  constructor(data?: PartialMessage<ListGatewaysRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ListGatewaysRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "pagination", kind: "message", T: PaginationRequest },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListGatewaysRequest {
    return new ListGatewaysRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListGatewaysRequest {
    return new ListGatewaysRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListGatewaysRequest {
    return new ListGatewaysRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListGatewaysRequest | PlainMessage<ListGatewaysRequest> | undefined, b: ListGatewaysRequest | PlainMessage<ListGatewaysRequest> | undefined): boolean {
    return proto3.util.equals(ListGatewaysRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ListGatewaysResponse
 */
export class ListGatewaysResponse extends Message<ListGatewaysResponse> {
  /**
   * gateways contains the list of gateways
   *
   * @generated from field: repeated gitpod.v1.Gateway gateways = 1;
   */
  gateways: Gateway[] = [];

  /**
   * pagination contains the pagination response
   *
   * @generated from field: gitpod.v1.PaginationResponse pagination = 2;
   */
  pagination?: PaginationResponse;

  constructor(data?: PartialMessage<ListGatewaysResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ListGatewaysResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "gateways", kind: "message", T: Gateway, repeated: true },
    { no: 2, name: "pagination", kind: "message", T: PaginationResponse },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListGatewaysResponse {
    return new ListGatewaysResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListGatewaysResponse {
    return new ListGatewaysResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListGatewaysResponse {
    return new ListGatewaysResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListGatewaysResponse | PlainMessage<ListGatewaysResponse> | undefined, b: ListGatewaysResponse | PlainMessage<ListGatewaysResponse> | undefined): boolean {
    return proto3.util.equals(ListGatewaysResponse, a, b);
  }
}

/**
 * Gateway represents a system gateway that provides access to services
 *
 * @generated from message gitpod.v1.Gateway
 */
export class Gateway extends Message<Gateway> {
  /**
   * name is the human-readable name of the gateway. name is unique across all gateways.
   *
   * @generated from field: string name = 1;
   */
  name = "";

  /**
   * url of the gateway
   *
   * @generated from field: string url = 2;
   */
  url = "";

  /**
   * region is the geographical region where the gateway is located
   *
   * @generated from field: string region = 3;
   */
  region = "";

  constructor(data?: PartialMessage<Gateway>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.Gateway";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "region", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Gateway {
    return new Gateway().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Gateway {
    return new Gateway().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Gateway {
    return new Gateway().fromJsonString(jsonString, options);
  }

  static equals(a: Gateway | PlainMessage<Gateway> | undefined, b: Gateway | PlainMessage<Gateway> | undefined): boolean {
    return proto3.util.equals(Gateway, a, b);
  }
}

